export default __webpack_public_path__ + "9c16e72ea4cc573fcf0e717975bdb516.png";